// extracted by mini-css-extract-plugin
export default {"wrap":"EventResponses_wrap__HucQ4"};